import { TableCellAlignmentEnum } from './TableCellAlignmentEnum';
import { TableColumnType } from './TableColumnType';

export class TableColumnOptions {
  public styleExpression?: string;
  public alignment?: TableCellAlignmentEnum;
  public ellipsisLength?: number;
  public isSticky?: boolean;
  public toolTip?: (row: unknown) => string;
  public showTotal?: boolean;
  public columnType?: TableColumnType;
  public showTotalText?: boolean;
  public conditionalCss?: (row: unknown) => string;
  public isHtml?: boolean;
  constructor(
    columnType?: TableColumnType,
    styleExpression?: string,
    alignment?: TableCellAlignmentEnum,
    ellipsisLength?: number,
    isSticky?: boolean,
    toolTip?: (row: unknown) => string,
    showTotal?: boolean,
    showTotalText?: boolean,
    conditionalCss?: (x: unknown) => string,
    isHtml?: boolean,
  ) {
    this.columnType = columnType ?? TableColumnType.Default;
    this.styleExpression = styleExpression ?? '';
    this.alignment = alignment ?? TableCellAlignmentEnum.LEFT;
    this.ellipsisLength = ellipsisLength ?? 0;
    this.isSticky = isSticky ?? false;
    this.toolTip = toolTip;
    this.showTotal = showTotal ?? false;
    this.showTotalText = showTotalText ?? false;
    this.conditionalCss = conditionalCss;
    this.isHtml = isHtml ?? false;
  }
}
